import React from "react";
import { Link } from "gatsby";

import AbstractHeader from "./AbstractHeader";
import User from "../User";
import Logo from "../Logo";
import isBrowser from "../../utils/isBrowser";
import { Permission } from "../../utils/permissions";

const isActive = (path) => {
    if (!isBrowser()) return;
    const location = window.location.pathname.endsWith("/") ? window.location.pathname.slice(0, -1) : window.location.pathname;
    path = path.endsWith("/") ? path.slice(0, -1) : path;
    return location.startsWith(path);
};

const HeaderLink = ({ children, to }) => (
    <Link
        to={ to }
        css={{
            color: isActive(to) ? "var(--green)" : "grey",
            padding: 15,
        }}
    >
        { children }
    </Link>
);

export default ({ code, name, icon, permissions }) => (
    <>
        <AbstractHeader>
            {
                code
                ?   <Link
                        to={ "/" + code }
                        css={{
                            display: "flex",
                            alignItems: "center",
                        }}
                    >
                        {
                            icon
                            ?   <img
                                    alt="Logo"
                                    src={ icon }
                                    height={ 64 }
                                    width={ 64 }
                                    css={{
                                        padding: 15,
                                        height: "100%",
                                    }}
                                />
                            :   null
                        }
                        {
                            name
                            ?   <div css={{
                                    fontWeight: 500,
                                }}>
                                    { name }
                                </div>
                            :   null
                        }
                    </Link>
                :   <Link
                        to="/"
                        css={{
                            height: "100%",
                            padding: 15,
                            display: "flex",
                            alignItems: "center",
                        }}
                    >
                        <Logo />
                    </Link>
            }

            <User />
        </AbstractHeader>

        {
            code
            ?   <div css={{
                    borderBottom: "1px solid rgba(200, 200, 200, .2)",
                }}>
                    <div css={{
                        padding: "0 15px",
                        height: "100%",
                        maxWidth: 1000,
                        margin: "0 auto",
                        display: "flex",
                        alignItems: "center",
                        fontSize: ".8em",
                        textTransform: "uppercase",
                        fontWeight: 500,
                        overflowX: "auto",
                        backgroundColor: "var(--dark)",
                    }}>
                        <HeaderLink to={ "/" + code + "/feedback" }>
                            Feedback
                        </HeaderLink>
                        {
                            permissions
                            ?   <HeaderLink to={ "/" + code + "/team" }>
                                    Team
                                </HeaderLink>
                            :   null
                        }
                        {
                            permissions === Permission.OWNER || permissions === Permission.ADMIN
                            ?   <HeaderLink to={ "/" + code + "/settings" }>
                                    Settings
                                </HeaderLink>
                            :   null
                        }
                    </div>
                </div>
            :   null
        }
    </>
);
